<template>
    <div class="tower-detail" >
       <ul class="header"  >
				<li class="title" >{{towerTitle}}</li>
                <li class="tip">热门楼层</li>
				<li class="btn" v-on:click="$parent.isShowTower(false)"  ></li>
			</ul>
       <ul class="footer" >
           <div class="title-f" key="title-f-1" >建筑详情</div>
           <li v-for="(item,index) in towerData.towerDetail " :key="index+'1'" style="width:100%;overflow:hidden;" >
               <span class="title" >{{item.name}}：</span><span class="detail" >{{item.detail}} </span>
           </li>
           <div class="title-f" v-if="towerData.signRecords" key="title-f-2" style="margin-top:15px" >签约记录</div>
           <li v-for="(item,index) in towerData.signRecords " :key="index+'2'" style="width:100%;overflow:hidden;" >
               <span class="title" >{{item.lookBuildingName}}：</span><span class="detail" >{{item.curCompany}} </span>
           </li>
           <div class="title-f" v-if="towerData.lookRecords" key="title-f-3" style="margin-top:15px" >最近看房记录 </div>
           <li v-for="(item,index) in towerData.lookRecords " :key="index+'3'" style="width:100%;overflow:hidden;" >
               <span class="title" >{{item.lookFloorInfo}}：</span><span class="detail" >{{item.curCompany}} </span>
           </li>
       </ul>
    </div>
</template>
<script>
    export default {
		props:{
            towerTitle:String,
            towerData:Object
		},
        data(){
            return {

            }
        },
        mounted(){
			
        },
        methods:{
			test(){
				console.log('test')
			}
        },
        components:{
        }
    }
</script>
<style scoped lang="scss" >
    .tower-detail{
        position:fixed;
        z-index:111;
        background:#fff;
        width:420px;
        height:596px;
        top:0;
        bottom:0;
        margin:auto;
        left:10px;
        border-radius:8px;
        
        .header{
            width:420px;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            height:80px;
            position: fixed;
            z-index: 100;
            background: #f3f3f3;
            color:#383838;
            font-weight: 800;
            display:flex;
            padding:20px;
            box-sizing: border-box;
            li{
                line-height: 40px;
            }
            .tip{
                font-size:14px;
                font-weight: 100;
                color:#f25B6D;
                height: 30px;
                margin-top: 7px;
                margin-left: 10px;
                line-height:2;
                padding-left:5px;
                padding-right:5px;
                border-radius:5px;
                background:#f2dadc;
            }
            .title{
                font-size:26px;

            }
            .btn{
                width: 35px;
                height: 35px;
                transform: scale(0.5);
                -moz-transform: scale(0.5);
                -webkit-transform: scale(0.5);
                background: url('../assets/close1.png')100% 100% no-repeat;
                background-position: center;
                // background-color:#ccc;
                border-radius:50%;
                cursor: pointer;
                position:absolute;
                right:20px;
                top:20px;
            }
        }
        .footer{
           overflow: hidden;
            overflow: auto;
            -webkit-overflow-scrolling: touch;
            height:466px;
            li:nth-child(odd){
                // background:#fff5f2
            }
            li{
                padding:2px;
            }
            .title-f{
                font-weight: 900;
                font-size:16px;
                color:#000;
                border-bottom:#ccc solid 1px;
            }
            line-height:2;
            padding:20px;
            padding-top:100px;
            .title{
                color:#666;
                font-size:18px;
                width:35%;
                display:block;
                float:left;
                text-overflow:ellipsis;
                white-space:nowrap; 
                overflow:hidden;
                padding-right:10px;
                box-sizing: border-box;
                // text-align: right;
            }
            .detail{
                color:#1A1A1A;
                font-size:18px;
                width:65%;
                display:block;
                float:left;
            }
        }
    }
    @media screen and (max-width:800px) {
        .tower-detail{
           width:75%;
           left:0;
           right:0;
           height:50%;
           background:rgba(255,255,255,0.9);
           .header{
               height:55px;
               padding:10px;
               width:75%;
               .btn{
                   top:3px;
                   right:3px;
               }
           }
           .footer{
               height:210px;
               padding-top:65px;
               .title{
                   
                   font-size:16px;
                   width:40%;
               }
               .detail{
                   font-size:16px;
                   width:60%;
               }
           }
        }
    }
</style>




// WEBPACK FOOTER //
// src/commonComponents/TowerDetail.vue